import styled from 'styled-components';

export const Header = styled.header`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 1rem 1rem 1rem;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
  padding: 1rem;
`;

export const Subtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};
  font-size: 1rem;

  & > span.date {
    font-weight: 700;
  }
`;
